export default "https://cdn-static.gokick.com/assets/d05c895b658955f243e3d6e9c630166e56cf3faa/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";